export const IconPrintCv: {
  name: 'icon_print_cv-040f8677b8a6'
} = {
  name: 'icon_print_cv-040f8677b8a6'
}
